import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import Shell from '../components/ui/Shell';

/**
 * Fallback route for the bare origin. The candidate SPA is invitation-only
 * — a URL without a token shouldn't leak any call-to-action.
 */
export default function HomePage() {
  return (
    <Shell centered maxWidth="narrow">
      <Card>
        <CardHeader>
          <CardTitle>Voice Interview</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            This application is invitation only. Please use the link shared by your
            recruiter to start your interview.
          </p>
        </CardContent>
      </Card>
    </Shell>
  );
}
